import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Package, Stethoscope, Receipt, KeyRound, ClipboardList } from "lucide-react";

const linkClass = ({ isActive }) =>
    `flex items-center gap-2 border px-3 py-2 text-xs font-semibold uppercase tracking-[0.14em] ${
        isActive
            ? "border-veda-inverse bg-veda-inverse text-veda-onInverse"
            : "border-veda-border bg-veda-surface text-veda-onSurface"
    }`;

export default function AdminLayout() {
    return (
        <div className="pb-16">
            <div className="border-b border-veda-border">
                <div className="veda-container py-8 md:py-10">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-veda-brand">
                        Sushen Herbs admin
                    </p>
                    <h1 className="font-display mt-1 text-4xl text-veda-onSurface md:text-5xl">
                        Command center
                    </h1>
                </div>
            </div>
            <div className="sticky top-16 z-10 border-b border-veda-border bg-veda-surface">
                <div className="veda-container no-scrollbar flex gap-2 overflow-x-auto py-3">
                    <NavLink to="/admin/overview" className={linkClass}>
                        <LayoutDashboard size={13} /> Overview
                    </NavLink>
                    <NavLink to="/admin/products" className={linkClass}>
                        <Package size={13} /> Products
                    </NavLink>
                    <NavLink to="/admin/doctors" className={linkClass}>
                        <Stethoscope size={13} /> Doctors
                    </NavLink>
                    <NavLink to="/admin/orders" className={linkClass}>
                        <Receipt size={13} /> Orders
                    </NavLink>
                    <NavLink to="/admin/users" className={linkClass}>
                        <KeyRound size={13} /> Users
                    </NavLink>
                    <NavLink to="/admin/quiz" className={linkClass}>
                        <ClipboardList size={13} /> Quiz
                    </NavLink>
                </div>
            </div>
            <div className="veda-container pt-6 md:pt-10">
                <Outlet />
            </div>
        </div>
    );
}
